import { render, staticRenderFns } from "./AddVideo360.modal.vue?vue&type=template&id=2c465f50&"
import script from "./AddVideo360.modal.vue?vue&type=script&lang=js&"
export * from "./AddVideo360.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports